import XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';

export const SEGMENT_LABELS = {
    champions: 'Champions',
    loyal: 'Leales',
    new: 'Nuevos',
    at_risk: 'En riesgo',
    inactive: 'Inactivos',
    active: 'Activos',
    no_purchase: 'Sin compra'
};

export const CHANNEL_LABELS = {
    online_store: 'Tienda en línea',
    physical_store: 'Sucursal física',
    amazon: 'Amazon',
    mercadolibre: 'Mercado Libre',
    other: 'Otro'
};

export const SOURCE_LABELS = {
    nefropolis: 'Nefrópolis',
    odoo: 'Odoo',
    amazon: 'Amazon',
    mercadolibre: 'Mercado Libre',
    manual: 'Manual',
    other: 'Otro'
};

export const money = value => Number(value || 0).toLocaleString('es-MX', {
    style: 'currency', currency: 'MXN'
});

export const dateText = value => value
    ? new Date(value).toLocaleDateString('es-MX', {
        timeZone: 'America/Mexico_City', year: 'numeric', month: 'short', day: 'numeric'
    })
    : '—';

export const downloadClientExport = (rows, filename = 'clientes-nefropolis') => {
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = { Sheets: { Clientes: worksheet }, SheetNames: ['Clientes'] };
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    }), `${filename}.xlsx`);
};

export const currentYearRange = () => ({
    dateFrom: `${new Date().getFullYear()}-01-01`,
    dateTo: `${new Date().getFullYear()}-12-31`
});
